import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

// API
import { retrieveManagedPositions } from "@/Common/api/location";

// Helpers
import { getDepartmentalPosition, isProducerPosition } from "@/Common/helpers/Positions";

function useManagedPositions({ queryKeys = [], queryOpts = {}, onSuccess = () => {} }) {
	const location = useSelector((state) => state.location.location);
	const response = useQuery({
		queryKey: [...queryKeys, "managedPositions", location?.locationId],
		queryFn: async () => {
			const result = await retrieveManagedPositions(location?.locationId);
			const newResponse = onSuccess(result);
			return newResponse || result;
		},
		enabled: !!location?.locationId,
		...queryOpts,
	});

	const methods = {
		isPositionManaged: useCallback((position) => response?.data?.includes(position) ?? false, [response?.data]),
		matchPosition: useCallback((position) => response?.data?.filter((item) => item.includes(position)), [response?.data]),
	};

	return { ...response, ...methods };
}

function useIsProducer(position = "") {
	return isProducerPosition(position);
}

const useSingularPosition = (position) => getDepartmentalPosition(position);

export { useManagedPositions, useIsProducer, getDepartmentalPosition, useSingularPosition };
